import './registerServiceWorker'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "materialize-css/dist/css/materialize.min.css"
import marked from "marked";
import { lineNumbers } from "./services/AddLineNumbers";
import "./assets/css/tomorrow.css";
import Component from "vue-class-component";
import M from "materialize-css";
import '@mdi/font/css/materialdesignicons.css'
import "./assets/css/bootstrap-grid.min.css";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "./globalStyles.scss";
import { string_to_slug } from './utils'

Vue.prototype.$M = M;

// Register the router hooks with their names
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate" // for vue-router 2.2+
]);

// override marked heading to replace id text with custom text
const renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
  if(href && href.startsWith('#')) {
    return `<a href="${location.origin + location.pathname + '#' + string_to_slug(href)}">${text}</a>`
  } 
  return `<a href="${href}">${text}</a>`
};
renderer.heading = function (text, level) {
  let link;
  if (text.includes("{#")) {
    link = text.slice(text.indexOf("{#") + 2, text.indexOf("}"));
  }
  text = text.split("{#")[0];
  let h = `<a name="${string_to_slug(text)}"></a><h${level} ${
    link ? 'id="' + link + '"' : ""
    }>${text}</h${level}>`;
  return h;
};
renderer.code = function (code, lang) {
  return lineNumbers(code, lang);
};
renderer.codespan = function (code) {
  return `<code id="inline-code" class="d-inline p-0">${code}</code>`;
};
renderer.image = function (href) {
  return `<img class="materialboxed" src="${href}">`
}

marked.setOptions({
  breaks: true,
  smartypants: true,
  renderer: renderer
});

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#94949e", // gray
        background: "#f5f5f5",
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 720,
      lg: 960,
      xl: 1140,
    },
  },
});

export const eventBus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
